<template>
    <div class="min-h-screen w-full flex justify-center items-center">
        <p>Page Not found</p>
    </div>
</template>

<script>
    export default {

    }
</script>
